import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

const categoryImages: Record<string, string> = {
  "celebrity-scandal":
    "https://readdy.ai/api/search-image?query=Dramatic%20red%20carpet%20celebrity%20event%20with%20camera%20flashes%2C%20paparazzi%20photography%2C%20luxurious%20atmosphere%2C%20warm%20dark%20tones%2C%20cinematic%20lighting%2C%20glamorous%20entertainment%20scene&width=800&height=600&seq=cat-celebrity-scandal&orientation=landscape",
  "influencer-flop":
    "https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20setup%20with%20ring%20lights%20and%20professional%20cameras%2C%20modern%20influencer%20content%20creation%20space%2C%20warm%20interior%20lighting%2C%20creative%20digital%20media%20environment&width=800&height=600&seq=cat-influencer-flop&orientation=landscape",
  "social-hot":
    "https://readdy.ai/api/search-image?query=Breaking%20news%20concept%20with%20dramatic%20lighting%2C%20newspaper%20headlines%2C%20journalistic%20photography%2C%20warm%20and%20dark%20atmosphere%2C%20media%20and%20press%20theme&width=800&height=600&seq=cat-social-hot&orientation=landscape",
  "exclusive-expose":
    "https://readdy.ai/api/search-image?query=Investigative%20journalism%20concept%20with%20magnifying%20glass%20on%20documents%2C%20dramatic%20lighting%2C%20detective%20theme%2C%20warm%20dark%20tones%2C%20mysterious%20atmosphere&width=800&height=600&seq=cat-exclusive-expose&orientation=landscape",
  "daily-gossip":
    "https://readdy.ai/api/search-image?query=Stack%20of%20colorful%20tabloid%20magazines%20and%20newspapers%20on%20table%2C%20warm%20cozy%20lighting%2C%20editorial%20photography%2C%20entertainment%20news%20theme%2C%20vibrant%20yet%20warm%20atmosphere&width=800&height=600&seq=cat-daily-gossip&orientation=landscape",
  "deep-dive":
    "https://readdy.ai/api/search-image?query=Research%20desk%20with%20documents%20and%20detective%20board%20with%20red%20strings%20connecting%20photos%2C%20dramatic%20lighting%2C%20investigation%20theme%2C%20warm%20dark%20tones%2C%20cinematic%20atmosphere&width=800&height=600&seq=cat-deep-dive&orientation=landscape",
};

export default function CategoryGrid() {
  const mainCategories = categories.slice(0, 3);
  const subCategories = categories.slice(3);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            独家<span className="text-primary-500">爆料</span>分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            六大板块全面覆盖，你想看的瓜这里都有
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-4">
          {mainCategories.map((cat, idx) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`group relative overflow-hidden rounded-lg ${
                idx === 0
                  ? "lg:w-1/2"
                  : "lg:w-1/4"
              }`}
            >
              <div className="relative overflow-hidden rounded-lg h-64 md:h-72 lg:h-80">
                <img
                  src={categoryImages[cat.slug]}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="w-8 h-8 flex items-center justify-center bg-primary-500/90 rounded-lg">
                      <i className={`${cat.icon} text-white text-sm`}></i>
                    </span>
                    <span className="text-xs text-primary-300 font-medium">
                      {cat.articleCount}篇爆料
                    </span>
                  </div>
                  <h3 className="font-heading text-lg md:text-xl font-bold text-white mb-1">
                    {cat.name}
                  </h3>
                  <p className="text-white/70 text-xs line-clamp-1">
                    {cat.description}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          {subCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-5 hover:bg-background-50/80 transition-colors border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
                <span className="text-xs text-foreground-400">
                  {cat.articleCount}条内容
                </span>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-950 mb-1 group-hover:text-primary-500 transition-colors">
                {cat.name}
              </h3>
              <p className="text-foreground-500 text-xs leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}